<div class="input-container">
    <label for="storage_dropbox_access_token" trans>Access Token</label>
    <input type="text" id="storage_dropbox_access_token" name="storage_dropbox_access_token" [(ngModel)]="state.server['storage_dropbox_access_token']" required>
</div>

<div class="input-container">
    <label for="storage_dropbox_root" trans>Root Directory</label>
    <input type="text" id="storage_dropbox_root" name="storage_dropbox_root" [(ngModel)]="state.server['storage_dropbox_root']" placeholder="/">
</div>
